import { useCallback, useMemo } from "react";

import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import useUiuxStore from "src/store/useUiuxStore";

import { TQC2090_R01_LINE_OPTIONS } from "./Dto_TQC2090_R01";
import { useTQC2090_R01Store } from "./Store_TQC2090_R01";

interface EmployeeSearchResult {
	empNo?: string;
	empNm?: string;
}

/**
 * 검사공정 / 검사자 / 검사구분 / 승인자 표시 영역.
 *
 * 검사공정은 탭에서 고른 라인을 그대로 보여주는 읽기 전용 항목이다.
 * 검사자와 승인자는 저장 시 수정된 행의 검사결과 헤더에 반영한다.
 */
export const Info_TQC2090_R01 = () => {
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
		TQC2090_R01Filter,
		TQC2090_R01Info,
		setTQC2090_R01Info,
	} = useTQC2090_R01Store();

	const workplaceNm = useMemo(
		() =>
			TQC2090_R01_LINE_OPTIONS.find(
				(line) => line.workplaceCd === TQC2090_R01Filter.workplaceCd,
			)?.workplaceNm ?? "",
		[TQC2090_R01Filter.workplaceCd],
	);

	const openEmployeeModal = useCallback(
		(field: "inspector" | "approvor") => {
			const isInspector = field === "inspector";
			setCodeSearchModalProps({
				category: isInspector ? "검사자" : "승인자",
				search: isInspector ? TQC2090_R01Info.inspectorEmp : TQC2090_R01Info.approvorEmpno,
				formName: "TQC2090_R01",
				isInfo: true,
				handleFoucsId: isInspector ? "tqc2090_inspectorEmp" : "tqc2090_approvorEmpno",
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () => {
					setTQC2090_R01Info(
						isInspector
							? { inspectorEmp: "", inspectorEmpNm: "" }
							: { approvorEmpno: "", approvorEmpNm: "" },
					);
				},
				onConfirm: (data: EmployeeSearchResult) => {
					setTQC2090_R01Info(
						isInspector
							? { inspectorEmp: data.empNo || "", inspectorEmpNm: data.empNm || "" }
							: { approvorEmpno: data.empNo || "", approvorEmpNm: data.empNm || "" },
					);
				},
			});
		},
		[setCodeSearchModalProps, setTQC2090_R01Info, TQC2090_R01Info],
	);

	return (
		<div className="flex items-center flex-wrap px-[12px] pt-[8px]">
			<InputForm
				title="검사공정"
				name="workplaceCd"
				value={workplaceNm}
				editable={false}
			/>

			<CodeForm
				label="검사자"
				name="inspectorEmp"
				value={TQC2090_R01Info.inspectorEmp}
				custNmValue={TQC2090_R01Info.inspectorEmpNm}
				handleFoucsId="tqc2090_inspectorEmp"
				handleChange={(e) => setTQC2090_R01Info({ inspectorEmp: e.target.value })}
				onDoubleClick={() => openEmployeeModal("inspector")}
			/>

			<InputForm
				title="검사구분"
				name="inspectType"
				value="초중종검사"
				editable={false}
			/>

			<CodeForm
				label="승인자"
				name="approvorEmpno"
				value={TQC2090_R01Info.approvorEmpno}
				custNmValue={TQC2090_R01Info.approvorEmpNm}
				handleFoucsId="tqc2090_approvorEmpno"
				handleChange={(e) => setTQC2090_R01Info({ approvorEmpno: e.target.value })}
				onDoubleClick={() => openEmployeeModal("approvor")}
			/>
		</div>
	);
};
